
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDiodes07 as ObiDiodes07Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-diodes-07.js';
 
 
 

 
 export const ObiDiodes07 = createComponent({
   react: React,
   tagName: 'obi-diodes-07',
   elementClass: ObiDiodes07Element,
   events: {
     
   }
  });
 
 